export const deTrendIdentification = {
  'navbar.menu.analyses.trendIdentification': 'Trendidentifikation',
  'trendIdentification.title': 'Trendidentifikation',
  'trendIdentification.fieldPlaceholder': 'Bitte Eintrag wählen',
  'trendIdentification.sidePanel.title': 'Wählen Sie Parameter',
  'trendIdentification.sidePanel.submitedCalculations.title': 'Übermittelte Berechnungen',
  'trendIdentification.sidePanel.submitedCalculations.label': 'Trendergebnisse',
  'trendIdentification.sidePanel.submitedCalculations.placeHolder': 'Wert gewählt',
  'trendIdentification.sidePanel.parameters.title': 'Neue Berechnung starten',
  'trendIdentification.sidePanel.parameters.tso.label': 'Übertragungsnetzbetreiber',
  'trendIdentification.sidePanel.parameters.start.label': 'Start',
  'trendIdentification.sidePanel.parameters.start.supportingText': 'Hinweis: Start muss ein Montag sein.',
  'trendIdentification.sidePanel.parameters.start.tooltip':
    'Um den erforderlichen Zeitraum von mind. 106 Wochen sicherzustellen, zuerst das Enddatum auswählen.',
  'trendIdentification.sidePanel.parameters.end.label': 'Ende',
  'trendIdentification.sidePanel.parameters.end.supportingText': 'Hinweis: Ende muss ein Sonntag sein.',
  'trendIdentification.sidePanel.parameters.measurmentParameters.label': 'Messgrößen',
  'trendIdentification.sidePanel.parameters.measurmentDevice.label': 'Messgerät',
  'trendIdentification.sidePanel.parameters.reset.label': 'Verwerfen',
  'trendIdentification.sidePanel.parameters.submit.label': 'Berechnungen übermitteln',
  'trendIdentification.content.title': 'Trendidentifikation',
  'trendIdentification.content.description':
    'Erkennen und visualisieren von Trends in Kenngrößen über ausgewählte Zeiträume hinweg.',
  'trendIdentification.deleteDialogue.title': 'Trendergebnis löschen',
  'trendIdentification.deleteDialogue.tooltip': 'Trendergebnis löschen',
  'trendIdentification.deleteDialogue.contentPart1': 'Möchtest du "',
  'trendIdentification.deleteDialogue.contentPart2':
    '" wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.',
  'trendIdentification.deleteDialogue.buttonLabel': 'Löschen',
  'trendIdentification.snackbarDeleteSuccess': 'Berechnung wurde erfolgreich gelöscht.',
  'trendIdentification.snackbarDeleteError': 'Berechnung konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.',
  'trendIdentification.modal.submitCalculation.title': 'Berechnung übermitteln',
  'trendIdentification.modal.submitCalculation.description':
    'Diese Trendberechnung mit den ausgewählten Parametern kann übermittelt und gespeichert werden. Die Berechnungen finden Sie dann unter „Trendergebnisse”. Sobald die Berechnungen abgeschlossen sind, können sie ausgewählt werden.',
  'trendIdentification.modal.submitCalculation.nameField.label': 'Name für Trendberechnung',
  'trendIdentification.modal.submitCalculation.nameField.placeholder': 'Namen eingeben',
  'trendIdentification.modal.submitCalculation.nameField.supportingText':
    'Hinweis: Erlaubte Zeichen sind a-zA-Z0-9äöüÄÖÜß\s\-_()/.',
  'trendIdentification.modal.submitCalculation.cancel': 'Verwerfen',
  'trendIdentification.modal.submitCalculation.submit': 'Berechnung übermitteln',
  'trendIdentification.dialogTextfieldValidationError':
    'Ungültige Zeichen erkannt. Bitte entfernen Sie nicht unterstützte Symbole.',
  'trendIdentification.dialogTextfieldValidationInvalidName': 'Bitte geben Sie einen gültigen Namen ein.',
  'trendIdentification.placeholder.title': 'Keine Parameter ausgewählt.',
  'trendIdentification.placeholder.description': 'Trendergebnis auswählen zur Visualisierung von Daten.',
  'trednIdentification.tableContainer.title': 'Trends',
  'trednIdentification.tableContainer.description':
    'In der Tabelle werden nur Einträge mit Daten angezeigt. Bis zu 6 Einträge können für die Visualisierung ausgewählt werden.',
  'trednIdentification.tableContainer.parameterConfiguration.title': 'Einstellparameter',
  'trednIdentification.tableContainer.parameterConfiguration.placeholder': 'Wert eingeben',
  'trednIdentification.tableContainer.parameterConfiguration.averageIncreasePerYear.label':
    'Durchschnittlicher Anstieg pro Jahr >',
  'trednIdentification.tableContainer.parameterConfiguration.averageIncreasePerYear.error': 'Nur Zahlen sind erlaubt.',
  'trednIdentification.tableContainer.parameterConfiguration.absoluteIncrease.label': 'Absolute Steigerung >',
  'trednIdentification.tableContainer.parameterConfiguration.absoluteIncrease.error': 'Nur Zahlen sind erlaubt.',
  'trednIdentification.tableContainer.parameterConfiguration.currentValue.label': 'Aktueller Wert >',
  'trednIdentification.tableContainer.parameterConfiguration.currentValue.error': 'Nur Zahlen sind erlaubt.',
  'trednIdentification.tableContainer.parameterConfiguration.durationOfIncreaseInWeeks.label':
    'Dauer des Anstiegs in Wochen >',
  'trednIdentification.tableContainer.parameterConfiguration.durationOfIncreaseInWeeks.error':
    'Nur Zahlen sind erlaubt.',
  'trednIdentification.tableContainer.parameterConfiguration.apply': 'Anwenden',
  'trednIdentification.tableContainer.noTrendFound.title': 'Keine Trends identifiziert.',
  'trednIdentification.tableContainer.noTrendFound.decription1':
    'Für die ausgewählten Parameter wurden keine Trends identifiziert. Sie können diese Trendberechnung löschen ',
  'trednIdentification.tableContainer.noTrendFound.decription2':
    'oder die Parameter anpassen und eine neue Berechnung übermitteln.',
  'trednIdentification.maximumNumberOfCells.error': 'Die maximale Anzahl der ausgewählten Optionen beträgt 6.',
  'trendIdentification.chart.title': 'Charts ausgewählter Trends',
  'trendIdentification.chart.subTitle':
    'Wählen Sie einen Trend in der obigen Tabelle aus, um dessen Diagramm hier anzuzeigen.',
  'trendIdentification.chart.segment1': 'Messgerät',
  'trendIdentification.chart.segment2': 'Messgrößen',
  'trendIdentification.chart.lineColor': 'Kennzeichnung:',
  'trendIdentification.chart.noSelection': 'Keine Auswahl',
  'trendIdentification.chart.measurementDevice': 'Messgerät',
  'trendIdentification.chart.nominalVoltage': 'Nennspannung',
  'trendIdentification.chart.date': 'Datum: ',
  '10minutes.current.currents': 'I_RMS',
  '10minutes.current.harmonics.order01': 'I_H01',
  '10minutes.current.harmonics.order02': 'I_H02',
  '10minutes.current.harmonics.order03': 'I_H03',
  '10minutes.current.harmonics.order04': 'I_H04',
  '10minutes.current.harmonics.order05': 'I_H05',
  '10minutes.current.harmonics.order06': 'I_H06',
  '10minutes.current.harmonics.order07': 'I_H07',
  '10minutes.current.harmonics.order08': 'I_H08',
  '10minutes.current.harmonics.order09': 'I_H09',
  '10minutes.current.harmonics.order10': 'I_H10',
  '10minutes.current.harmonics.order11': 'I_H11',
  '10minutes.current.harmonics.order12': 'I_H12',
  '10minutes.current.harmonics.order13': 'I_H13',
  '10minutes.current.harmonics.order14': 'I_H14',
  '10minutes.current.harmonics.order15': 'I_H15',
  '10minutes.current.harmonics.order16': 'I_H16',
  '10minutes.current.harmonics.order17': 'I_H17',
  '10minutes.current.harmonics.order18': 'I_H18',
  '10minutes.current.harmonics.order19': 'I_H19',
  '10minutes.current.harmonics.order20': 'I_H20',
  '10minutes.current.harmonics.order21': 'I_H21',
  '10minutes.current.harmonics.order22': 'I_H22',
  '10minutes.current.harmonics.order23': 'I_H23',
  '10minutes.current.harmonics.order24': 'I_H24',
  '10minutes.current.harmonics.order25': 'I_H25',
  '10minutes.current.thd': 'I_THD',
  '10minutes.current.unbalance': 'I_UNB',
  '10minutes.voltage.harmonics.even.order02': 'U_H02',
  '10minutes.voltage.harmonics.even.order04': 'U_H04',
  '10minutes.voltage.harmonics.even.order06': 'U_H06',
  '10minutes.voltage.harmonics.even.order08': 'U_H08',
  '10minutes.voltage.harmonics.even.order10': 'U_H10',
  '10minutes.voltage.harmonics.even.order12': 'U_H12',
  '10minutes.voltage.harmonics.even.order14': 'U_H14',
  '10minutes.voltage.harmonics.even.order16': 'U_H16',
  '10minutes.voltage.harmonics.even.order18': 'U_H18',
  '10minutes.voltage.harmonics.even.order20': 'U_H20',
  '10minutes.voltage.harmonics.even.order22': 'U_H22',
  '10minutes.voltage.harmonics.even.order24': 'U_H24',
  '10minutes.voltage.harmonics.odd.order03': 'U_H03',
  '10minutes.voltage.harmonics.odd.order05': 'U_H05',
  '10minutes.voltage.harmonics.odd.order07': 'U_H07',
  '10minutes.voltage.harmonics.odd.order09': 'U_H09',
  '10minutes.voltage.harmonics.odd.order11': 'U_H11',
  '10minutes.voltage.harmonics.odd.order13': 'U_H13',
  '10minutes.voltage.harmonics.odd.order15': 'U_H15',
  '10minutes.voltage.harmonics.odd.order17': 'U_H17',
  '10minutes.voltage.harmonics.odd.order19': 'U_H19',
  '10minutes.voltage.harmonics.odd.order21': 'U_H21',
  '10minutes.voltage.harmonics.odd.order23': 'U_H23',
  '10minutes.voltage.harmonics.odd.order25': 'U_H25',
  '10minutes.voltage.pst': 'U_PST',
  '10minutes.voltage.thd': 'U_THD',
  '10minutes.voltage.unbalance': 'U_UNB',
  '10minutes.voltage.voltagerms': 'U_RMS',
  '2hours.plt': 'U_PLT',
  'trendIdentification.filter.noData.title': 'Keine Ergebnisse gefunden.',
  'trendIdentification.filter.noData.description':
    'Für die aktuellen Einstellparameter wurden keine Ergebnisse gefunden. Bitte passen Sie die Parameter an.',
  'trendIdentification.modal.submitCalculation.submit.success':
    'Berechnung wurde erfolgreich übermittelt und wird nun verarbeitet.',
  'trendIdentification.modal.submitCalculation.submit.error':
    'Berechnung konnte nicht übermittelt werden. Bitte versuchen Sie es erneut. ',
  'trendIdentification.chart.placeholder.title': 'Kein Eintrag ausgewählt.',
  'trendIdentification.chart.placeholder.description':
    'Wählen Sie einen Eintrag aus der obigen Tabelle aus, um den Trend als Diagramm zu visualisieren.',
};
